import { useTranslation } from 'react-i18next';

import { useTeamsScheduleStore } from '@/apps/TeamsSchedule/stores/useTeamsScheduleStore';

interface TeamsConfigProps {
  onClose: () => void;
}

export default function TeamsConfig({ onClose }: TeamsConfigProps) {
  const { t } = useTranslation();
  const { disconnect } = useTeamsScheduleStore();

  const handleDisconnect = async () => {
    await disconnect();
    onClose();
  };

  return (
    <div className="h-full flex flex-col items-center justify-center">
      <button
        className="px-4 py-2 text-sm text-gray-600 hover:text-gray-800 hover:bg-gray-100 rounded-lg transition-colors flex items-center gap-2"
        onClick={handleDisconnect}
      >
        <svg
          className="w-4 h-4"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
          />
        </svg>
        {t('teamsSchedule.disconnect')}
      </button>
    </div>
  );
}
